import { BaseNode } from './base/BaseNode';

export class Paragraph extends BaseNode {
  constructor() {
    super('paragraph');
  }

  get schema() {
    return {
      content: 'inline*',
      group: 'block',
      parseDOM: [{ tag: 'p' }],
      toDOM() {
        return ['p', 0] as const;
      },
    };
  }
}
